export default {
    deviceName: 'Имя устройства',
    deviceNumber: 'идентификатор устройства',
    recordTime: 'Время записи',
    mapViewAll: 'Карта посмотреть все',
    distance: 'расстояние',
    flightAltitude: 'Высота полета (относительная высота)',
    positionCoordinates: 'Координаты положения',
    copyLocationData: 'Копировать координаты',
    detectionRecord: 'Запись обнаружения',
    signalStrength: 'сила сигнала',
}